import { Currency } from '@/core/currency/interfaces';

const BWP: Currency = {
    name: 'Botswana Pula',
    demonym: 'Botswana',
    majorSingle: 'Pula',
    majorPlural: 'Pula',
    codeNumeric: '072',
    symbol: 'P',
    symbolNative: 'P',
    minorSingle: 'Thebe',
    minorPlural: 'Thebe',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'BWP',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default BWP;
